import React from 'react';
import { KPICard } from '@/components/ui';
import type { ProgressStats } from '../types/construction-progress.types';

interface Props {
  stats?: ProgressStats;
  isLoading?: boolean;
}

export const ProgressKPIBoard: React.FC<Props> = ({ stats, isLoading }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <KPICard
        title="Tổng số nhật ký"
        value={stats?.totalLogs || 0}
        icon="ri-book-read-line"
        variant="primary"
        isLoading={isLoading}
      />
      <KPICard
        title="Sản lượng hoàn thành"
        value={stats?.approvedQuantity.toLocaleString() || 0}
        icon="ri-bubble-chart-line"
        variant="success"
        suffix=" ĐV"
        isLoading={isLoading}
      />
      <KPICard
        title="Chờ phê duyệt"
        value={stats?.pendingReviewCount || 0}
        icon="ri-time-line"
        variant="warning"
        isLoading={isLoading}
      />
      <KPICard
        title="Tỉ lệ hoàn thành"
        value={stats ? Math.round(stats.completionRate) : 0}
        icon="ri-pie-chart-line"
        variant="info"
        suffix="%"
        isLoading={isLoading}
      />
    </div>
  );
};
